var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaralibro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.49 34.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.63,13.9l-6.19-10.73c-1.14-1.97-3.24-3.18-5.51-3.18h-12.38c-2.27,0-4.37,1.21-5.51,3.18L.85,13.9c-1.14,1.97-1.14,4.39,0,6.36l6.19,10.73c1.14,1.97,3.24,3.18,5.51,3.18h12.38c2.27,0,4.37-1.21,5.51-3.18l6.19-10.73c1.14-1.97,1.14-4.39,0-6.36ZM25.82,7.94c-.34,0-.69-.02-1.03,0-.68.05-1.37.08-2.04.19-.32.05-.63.21-.91.37-.37.21-.54.57-.54.99-.02,1.32-.04,2.63-.05,3.95,0,.02,0,.04.01.09.07,0,.15,0,.23,0,1.15,0,2.31,0,3.46,0,.19,0,.38.03.57.05.18.01.26.09.23.29-.1.57-.17,1.15-.28,1.73-.16.89-.35,1.77-.51,2.66-.03.16-.12.15-.23.15-1.05,0-2.1.01-3.16.02-.13,0-.26,0-.42,0v.31c0,3.74,0,7.48,0,11.22q0,.27-.26.27c-1.51,0-3.01,0-4.52,0h-.25c-.04-3.95-.09-7.88-.13-11.84h-4.32c.02-1.58.04-3.12.07-4.7h4.3c0-.16,0-.28,0-.41.01-1.25.02-2.5.03-3.75,0-.86.14-1.7.43-2.52.55-1.52,1.66-2.4,3.19-2.81,1.21-.32,2.44-.36,3.68-.33.75.01,1.51.06,2.26.09.07,0,.13.01.22.02v3.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaralibro);
export default __webpack_public_path__ + "static/media/Caralibro.2faef181e8a6a540e2f26ad36b308c3a.svg";
export { ForwardRef as ReactComponent };